module.exports = __webpack_public_path__ + "static/media/fr-FR.59df8570.md";